module.exports = __webpack_public_path__ + "static/icons/icon-ski-pass-79e3e054c44f8c9aa66afbaa7e28e179.svg";